<!-- <div>
  <div (window:resize)="resizeCanvas()" class="position-relative border border-1 rounded-1 bg-white" #signatureWrapper> -->
    <signature-pad #signature class="signature-pad" [options]="options" (drawStart)="drawStart()"
      (drawEnd)="drawComplete()"></signature-pad>
    <!-- <span class="position-absolute top-0 end-0 mt-3 me-3 text-info cursor-pointer" (click)="clear()">clear
      signature</span>
  </div>
</div> -->